import { MobileVehicleList } from "@/pages/master-data-vehicle-list/ui/mobile/vehicle-list";
import { ScrollToTop } from "@/shared/lib/ScrollToTop";
import { BaseButton } from "@/shared/ui/BaseButton";
import { BaseIcon } from "@/shared/ui/BaseIcons";
import { BasePagination } from "@/shared/ui/base-pagination";
import { BasePaginationControl } from "@/shared/ui/base-pagination-control";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { Link } from "@tanstack/react-router";
import type React from "react";
import type { MasterDataVehicleListPageProps } from "../model";
import { VehicleTable } from "./vehicle-table";
// import { SearchFormCard } from "./SearchForms";

export const MasterDataVehicleListPageUi: React.FC<
  MasterDataVehicleListPageProps
> = (props) => {
  // TODO: 検索機能を実装する
  // const [showFilters, setShowFilters] = useState(false);
  // const [receptionStatusFilter, setReceptionStatusFilter] =
  //   useState<RECEPTION_STATUS>();
  // const [contractStatusFilter, setContractStatusFilter] =
  //   useState<CONTRACT_STATUS>();

  // const filteredParamCount = useMemo(() => {
  //   const count = Object.values(props.getDraftOffersCargosParams ?? {}).filter(
  //     (v) => v !== null && v !== undefined,
  //   ).length;
  //   return (
  //     count + (receptionStatusFilter ? 1 : 0) + (contractStatusFilter ? 1 : 0)
  //   );
  // }, [
  //   props.getDraftOffersCargosParams,
  //   receptionStatusFilter,
  //   contractStatusFilter,
  // ]);

  const pagination = props.vehicles.data?.pagination;

  return (
    <Stack px={{ xs: 2, sm: 4 }} pb={2} spacing={{ xs: 3, sm: 4 }}>
      <ScrollToTop />
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
          }}
        >
          車両管理
        </Typography>
        <BaseButton
          component={Link}
          variant="contained"
          sx={{
            fontSize: "16px",
          }}
          startIcon={<BaseIcon name="plus" htmlColor="white" />}
          onClick={props.onCreateVehicleClick}
        >
          車両を新規登録する
        </BaseButton>
      </Stack>
      {/* <Stack spacing={1}>
        <Box display="flex" justifyContent="space-between">
          <BaseButton
            sx={{
              paddingRight: 1,
              borderColor: "grey.300",
              color: "grey.700",
            }}
            variant="outlined"
            startIcon={<BaseIcon name="filter" />}
            onClick={() => setShowFilters(!showFilters)}
          >
            <Typography fontWeight={700} mr={1}>
              フィルター
            </Typography>
            <Box
              width={"24px"}
              height={"24px"}
              display="flex"
              justifyContent="center"
              alignItems="center"
              p={0}
              borderRadius="50%"
              bgcolor="primary.500"
              color="white"
            >
              <Typography>{filteredParamCount}</Typography>
            </Box>
          </BaseButton>
        </Box>
        <Collapse in={showFilters}>
          <SearchFormCard
            onGetOffersCargosParamsChange={
              props.onGetDraftOffersCargosParamsChange
            }
            onGetOffersCargosParamsReset={
              props.onGetDraftOffersCargosParamsReset
            }
            onReceptionStatusFilterChange={setReceptionStatusFilter}
            onContractStatusFilterChange={setContractStatusFilter}
          />
        </Collapse>
      </Stack> */}
      {props.vehicles.status === "success" ? (
        <Stack direction="column" spacing={2}>
          {pagination && (
            <BasePaginationControl
              page={pagination.page}
              perPage={pagination.perPage}
              totalCount={pagination.totalCount}
              onPerPageChange={pagination.onPerPageChange}
            />
          )}

          <Box display={{ xs: "none", sm: "block" }}>
            <VehicleTable
              vehicles={props.vehicles.data}
              onVehicleClick={props.onShowVehicleClick}
            />
          </Box>

          <Box display={{ xs: "block", sm: "none" }}>
            <Box mx={-2}>
              <MobileVehicleList
                vehicles={props.vehicles.data}
                onVehicleClick={props.onShowVehicleClick}
              />
            </Box>
          </Box>

          {pagination && (
            <BasePagination
              page={pagination.page}
              perPage={pagination.perPage}
              totalCount={pagination.totalCount}
              onPageChange={pagination.onPageChange}
            />
          )}
        </Stack>
      ) : props.vehicles.status === "loading" ? (
        <Stack justifyContent="center" alignItems="center" p={4}>
          <CircularProgress />
        </Stack>
      ) : (
        <Typography color="error">エラーが発生しました</Typography>
      )}
    </Stack>
  );
};
